import { render } from "./NewsDetail.vue?vue&type=template&id=9d70ec4a&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=9d70ec4a&scoped=true&lang=css"

import exportComponent from "C:\\git\\fund\\vfund\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d70ec4a"]])

export default __exports__